<template>
    <client-page>
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">위탁신청</h2>
            </div>

            <form-input code="consignment-sale" skin="consignment-sale"></form-input>
        </v-container>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import FormInput from "@/components/client/ko/form/form-input.vue";

export default {
    components: {
        ClientPage,
        FormInput,
    },
};
</script>
